import { Form, Formik } from 'formik';
import { Button, Grid, Segment, Message, Icon, Header } from 'semantic-ui-react';
import { Workdest, Permit } from '../../../../app/models/permit';
import { returnPhoneOrEmpty } from '../../../../app/common/util/util';
import { observer } from 'mobx-react-lite';
import MyTextInput from '../../../../app/common/form/MyTextInput';
import MyZipCodeInput from '../../../../app/common/form/MyZipCodeInput';
import MyPhoneInput from '../../../../app/common/form/MyPhoneInput';
import { WorkdestFormValidationSchema } from '../../../../app/common/form/FormikFormValidations';

interface Props {
    updateWorkdest: (workdest: Workdest, permitId: number) => void,
    workdest: Partial<Permit>
}

export default observer(function PermitDetailedWorkdestEditForm({ 
    updateWorkdest, workdest
 }: Props) {
    function handleFinalFormSubmit(values: Partial<Permit>) {
        let newWorkdest: any = {
            // id: values.permitId,
            workdestCompany: values.workdestCompany,    
            workdestAddress: values.workdestAddress,    
            workdestAddress2: values.workdestAddress2,    
            workdestCity: values.workdestCity,    
            workdestState: values.workdestState,    
            workdestZipcode: values.workdestZipcode,    
            workdestPhone: values.workdestPhone,    
        };
        updateWorkdest(newWorkdest, values.permitId!);        
    }

    return (
        <Formik
            initialValues={workdest}
            onSubmit={(values) => handleFinalFormSubmit(values)}
            validationSchema={WorkdestFormValidationSchema}
        >
        {({handleSubmit, isSubmitting, dirty, isValid}) => (
            <Form className='ui form error' onSubmit={handleSubmit} autoComplete='off'>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Header as='h2' content='Update Work Destination Information' />
                            <Segment>
                                <label>Employer</label>
                                <MyTextInput name='workdestCompany' placeholder='Employer' tabIndex={1} />

                                <label>Address</label>
                                <MyTextInput name='workdestAddress' placeholder='Address' tabIndex={2} />

                                <label>Address 2</label>
                                <MyTextInput name='workdestAddress2' placeholder='Address 2' tabIndex={3} />

                                <label>City</label>
                                <MyTextInput name='workdestCity' placeholder='City' tabIndex={4} />

                                <label>State</label>
                                <Segment>WA</Segment>

                                <label>Zip Code</label>
                                <MyZipCodeInput name='workdestZipcode' placeholder='Zip Code' tabIndex={5} />

                                {!isValid && returnPhoneOrEmpty(workdest.workdestPhone!) === '' && (
                                    <Message icon color='red'>
                                        <Icon name='exclamation' />
                                        <Message.Content>
                                            <Message.Header>Invalid Phone</Message.Header>
                                            Please re-enter phone number as the following format (123) 123-1234.
                                        </Message.Content>
                                    </Message>
                                )}

                                <label>Phone</label>
                                <MyPhoneInput name='workdestPhone' placeholder='Phone' tabIndex={6} />
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Button 
                            disabled={!dirty || !isValid}
                            loading={isSubmitting}
                            color='teal' 
                            content='Update'
                            fluid 
                        />
                    </Grid.Row>
                </Grid>
            </Form>
        )}
        </Formik>
    )
})